import React from "react";
import { useHistory } from "react-router-dom";

function UpdatesPage() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="privacy-policy fade-in">
      <div className="privacy-header">
        <button className="back-button button-transition" onClick={handleGoBack}>
          ← Back
        </button>
        <h1 className="privacy-title">Website Updates</h1>
      </div>
      <p className="privacy-date">Last Updated: June 9, 2025</p>

      <div className="privacy-content form-transition">
        <section className="privacy-section section-transition">
          <h2>Recent Updates</h2>
          <div className="update-item">
            <h3>6/30/25</h3>
            <ul>
              <li>Added feature requests</li>
            </ul>
          </div>
          <div className="update-item">
            <h3>6/29/25</h3>
            <ul>
              <li>Added bug report</li>
            </ul>
          </div>
          <div className="update-item">
            <h3>6/9/25</h3>
            <ul>
              <li>CD rates went from 7, 14, 30, 60, 90 days and 1%, 2%, 3%, 4%, 5% Daily Percentage Yield to 7, 14, 30, 60, 90 days and .5%, 1%, 2%, 3%, 4% Daily Percentage Yield.</li>
              <li>Debt rate change from 1.5% to 1.75%</li>
              <li>CD eary refund change from 10% to 25%</li>
            </ul>
          </div>
          <div className="update-item">
            <h3>5/4/25</h3>
            <ul>
              <li>Increased garnish to 75%</li>
              <li>Auction profits are not garnished if user has debt</li>
            </ul>
          </div>
          <div className="update-item">
            <h3>4/11/25</h3>
            <ul>
              <li>life events should no longer boost students from last to first place</li>
              <li>Auctions now flash yellow when a bid occurs</li>
              <li>When a student selects an auction to bid it will turn blue</li>
            </ul>
          </div>
          <div className="update-item">
            <h3>4/3/25</h3>
            <ul>
              <li>Students can no longer changed their names.</li>
              <li>Teachers can change any students names</li>
              <li>Admins can change any teacher or students names and can reset anyones password.</li>
            </ul>
          </div>
          <div className="update-item">
            <h3>4/2/25</h3>
            <ul>
              <li>Teacher can now see student auctions for 7 days after they complete, up from 2 days.</li>
              <li>Auctions are no longer updated by polling. They are now updated with Server Sent Events. This should mean faster page updates with regards to auctions changing.</li>
            </ul>
          </div>
          <div className="update-item">
            <h3>1/6/25</h3>
            <ul>
              <li>Rank and Networth will now only be calculated once per day. Previously, it was done every time any user landed on the users page. This was not a problem when there were only a few students but now it is slowing the platform.</li>
              <li>Certificate of Deposits lengths and rates were unbalancing the game. As such, they have been adjusted to 7, 14, 30, 60, 90 days and 1%, 2%, 3%, 4%, 5% Daily Percentage Yield respectivly. Previously it was 14, 30, 50, 70, 90 with rates of 3%, 4%, 5%, 6% and 7%. This should give the teacher better control of the currencies.</li>
            </ul>
          </div>
        </section>

        <section className="privacy-section section-transition">
          <h2>How Updates Are Applied</h2>
          <p>
            These updates reflect our ongoing commitment to improve user experience and align with feedback.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>Stay Informed</h2>
          <p>
            Bookmark this page to stay informed about the latest improvements to our platform. If you have questions or suggestions, contact us at:
            <a href="mailto:SchoolBucks@proton.me" className="link-transition"> SchoolBucks@proton.me</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default UpdatesPage;
